import styled from '@emotion/styled'
import { FormItem } from '@/components'

export const AgentFormItem = styled(FormItem)`
  .ant-form-item-label {
    padding-bottom: 12px;
    font-weight: 500;
  }
`
